import React, { useState, useEffect, useLayoutEffect } from "react";
import styled from "styled-components";
import { RANGE_MAP, STYLES } from "../../constants";
import Slider from "rc-slider";

const Handle = Slider.Handle;
const RCRange = Slider.Range;

function Range({
  id,
  min = RANGE_MAP.min,
  max = RANGE_MAP.max,
  defaultValue,
  onAfterChange,
  ...restProps
}) {
  const [value, setValue] = useState(defaultValue);
  const [step, setStep] = useState(getStepSize(value[1]));

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useLayoutEffect(() => {
    const leftHandle = document.querySelector(`#${id} .label-1`);
    const leftHandlePos = leftHandle?.getBoundingClientRect()?.left;

    const rightHandle = document.querySelector(`#${id} .label-2`);
    const rightHandlePos = rightHandle?.getBoundingClientRect()?.left;

    const overlap = Math.abs(leftHandlePos - rightHandlePos);

    const isOverlapped = overlap < 19;

    if (isOverlapped) {
      const adjust =
        overlap < 6 ? Math.ceil(overlap * 2.5) : Math.ceil(overlap);
      leftHandle.style.textIndent = `-${adjust}px`;
      rightHandle.style.textIndent = `${adjust}px`;
    } else {
      leftHandle.style.textIndent = null;
      rightHandle.style.textIndent = null;
    }
  }, [value, id]);

  function handleChange(value) {
    setStep(getStepSize(value[1]));
    setValue(value);
  }

  return (
    <SContainer id={id}>
      <RCRange
        min={min}
        max={max}
        step={step}
        onChange={handleChange}
        onAfterChange={onAfterChange}
        value={value}
        handle={handle}
        {...restProps}
      />
    </SContainer>
  );
}

function handle(props) {
  const { value, offset, dragging, ...restProps } = props;
  const { className } = restProps;
  const labelClass = className.includes("handle-1") ? "label-1" : "label-2";
  const positionStyle = {
    position: "absolute",
    left: `${offset}%`,
    marginTop: "-30px",
    marginLeft: "-12px",
    minWidth: "25px",
    color: "black",
    textAlign: "center"
  };

  return (
    <div key={className}>
      {/*<div className="rc-slider-tooltip-placement-top" style={positionStyle}>
        <div className="rc-slider-tooltip-content">
          <div className="rc-slider-tooltip-arrow" />
          <div className="rc-slider-tooltip-inner" role="tooltip">
            {value}
          </div>
        </div>
      </div>*/}
      <b style={positionStyle} className={labelClass}>
        {value}
      </b>
      <Handle
        value={value}
        offset={offset}
        visible={1}
        dragging={dragging.toString()}
        {...restProps}
      />
    </div>
  );
}

function getStepSize(v) {
  return v >= 3.5 ? 0.1 : 0.5;
}

const SContainer = styled("div")`
  padding: 20px 7px 0;

  .rc-slider-disabled {
    background-color: transparent;
  }

  .rc-slider-handle {
    box-shadow: none !important;
    border-color: ${STYLES.color.blue};
    background: ${STYLES.color.blue};
  }

  .rc-slider-track {
    background: ${STYLES.color.blue};
  }

  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    border-color: ${STYLES.color.blue};
  }

  .rc-slider-disabled {
    .rc-slider-handle {
      border-color: #c5c5c5;
    }
    .rc-slider-track {
      background: #c5c5c5;
    }
    .rc-slider-handle {
      background: #c5c5c5;
    }
  }
`;

export default Range;
